import { Playlist } from '@/modules/player/components/playlist';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(Playlist);

export const roles: string[] = [];
export const path = '/player/playlist';
export const element = <AnimatedPage />